import { render, staticRenderFns } from "./WorkerData.vue?vue&type=template&id=d447ed3e"
import script from "./WorkerData.vue?vue&type=script&lang=js"
export * from "./WorkerData.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports